_ = require 'underscore'

# Mixing-in classes must implement a labelCreateUrl method and have a
# labelList property that the mixin can access.
module.exports = class LabelsHelper
  getLabels: ->
    @labelList.models

  dataForLabel: (label) ->
    _.extend label.toJSON(), { isActive: @hasLabel(label) }

  toggleLabelColor: (color) ->
    label = @getBoard().labelForColor(color)
    if label?
      @toggleLabel(label)

  hasLabel: (label) ->
    @labelList.contains(label)

  toggleLabel: (label) ->
    toggleOn = !@hasLabel(label)
    usesTemp = label.get('uses') + (if toggleOn then 1 else -1)
    @toggle('idLabels', label.id, toggleOn)
    # This affects sorting, so set it on the model so that it's sorted into the
    # right place immediately. Otherwise it'll jump after the server update.
    label.set('uses', usesTemp)

  createLabel: (name, color) ->
    label = _.find @getBoard().getLabels(), (label) ->
      label.get('name') == name && label.get('color') == color
    if label
      if !@hasLabel(label) then @toggleLabel(label)
      return

    @labelList.create(
      { name, color: color ? '', idBoard: @get('idBoard'), uses: 1 }
      { url: @labelCreateUrl() }
    )
    return



// WEBPACK FOOTER //
// ./app/scripts/models/internal/labels-helper.coffee